import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';    
import { UtilsService } from '@ascschool/services/utils.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef } from 'ng-zorro-antd/modal';             
import { SystemUserService } from '@ascschool/services/user/system-user.service';
import { SystemUser } from '@ascschool/model/user/system-user.model';
import { StaffDisability } from '@ascschool/model/user/staff-disbility.model';
import { Observable } from 'rxjs';
import { TypeOfDisabilityService } from '@ascschool/services/category/typeofdisability.service';
import { StaffService } from '@ascschool/services/user/staff.service';
import { StaffTypeOfDisabilityService } from '@ascschool/services/user/staff-typeofdisability.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-popup-giao-vien-phu-trach',
  templateUrl: './popup-giao-vien-phu-trach.component.html',
  styleUrls: ['./popup-giao-vien-phu-trach.component.scss']
})
export class PopUpGiaoVienPhuTrachComponent implements OnInit {
  @Input() dataTransmission: any;
  stafftypeofdisability =  new StaffDisability();
  isEditMode = false;
  systemUser = new SystemUser();
  errorMsg: string;
  isDisabled = false;
  validateForm!: FormGroup; 
  getTypeOfDisabilitysACFn: (value: any) => Observable<any>;
  typeOfDisabilitysSubscription: any;
  typeOfDisabilitysControl = new FormControl();
  constructor(
    private modal: NzModalRef,
    public utilsService: UtilsService,
    private service: StaffTypeOfDisabilityService,
    private typeOfDisabilitysService: TypeOfDisabilityService,
    private staffService : StaffService,
  ) {
    
  }
  GetById(id: number) {
    this.service.getStaffTypeOfDisabilityById(id).subscribe((res: any) => {
      this.stafftypeofdisability = res; 
      if(this.stafftypeofdisability.staffId){
        this.staffService.getById(this.stafftypeofdisability.staffId).subscribe(response =>{
          this.stafftypeofdisability.fullName = response.fullName; 
        });
        if(this.stafftypeofdisability.typeOfDisabilityId){
          this.typeOfDisabilitysService.GetSelectPagingById(this.stafftypeofdisability.typeOfDisabilityId).subscribe(re =>{ 
            this.typeOfDisabilitysControl.setValue({id:re.id , text: re.typeOfDisabilityName})
          })
        }
      }
    })
  }
  ngOnInit() {
    if(this.dataTransmission && this.dataTransmission.id > 0){  
      this.GetById(this.dataTransmission.id);
      this.isEditMode = true;
    } 
    this.loadTypeOfDisabilitys();
  }
  
  close() {
    this.destroyModal();
  }
  destroyModal(): void {
    this.modal.destroy(true);
  }
  loadTypeOfDisabilitys() {
    this.getTypeOfDisabilitysACFn = (value: any) => this.typeOfDisabilitysService.getSelectPaging({ searchTerm: value, PageIndex: 1, PageSize: 100 }).pipe(
      map(resp => resp.results.length > 0 ? resp.results.map(x => ({ id: x.id, text: x.typeOfDisabilityName })) : [{ id: null, text: 'Không có dữ liệu' }])
    );
    if (!this.typeOfDisabilitysSubscription) this.typeOfDisabilitysSubscription = this.typeOfDisabilitysControl.valueChanges.subscribe(() => {
      this.utilsService.bindOrUnBindTheId(this.stafftypeofdisability, 'typeOfDisabilityId', this.typeOfDisabilitysControl.value);
    });
  }
  changeTypeOfDisabilitys(control: FormControl) {
    this.typeOfDisabilitysControl = control;
  }

  UpdateClose() {  
      this.service.update(this.stafftypeofdisability).subscribe((res) => {
        if (res.statusCode == 0) {
          this.utilsService.notifyResponse(res);
          this.close();
        } else {
          this.utilsService.notifyResponse(res);
        }
      })
     
  }
 
}
